/*
 * Copyright (c) 2002-2017 "Neo Technology,"
 * Network Engine for Objects in Lund AB [http://neotechnology.com]
 *
 * This file is part of Neo4j.
 *
 * Neo4j is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export const KEYWORD = 'keyword';
export const LABEL = 'label';
export const VARIABLE = 'variable';
export const PARAMETER = 'parameter';
export const PROPERTY_KEY = 'propertyKey';
export const RELATIONSHIP_TYPE = 'relationshipType';
export const FUNCTION_NAME = 'function';
export const PROCEDURE_NAME = 'procedure';
export const CONSOLE_COMMAND_NAME = 'consoleCommand';
export const CONSOLE_COMMAND_SUBCOMMAND = 'consoleCommandSubcommand';
export const PROCEDURE_OUTPUT = 'procedureOutput';

// Return no autocompletion
export const NOOP = 'noop';

// Default
export const ALL = [
  VARIABLE,
  PARAMETER,
  PROPERTY_KEY,
  FUNCTION_NAME,
  KEYWORD,
].map(type => ({ type }));



// WEBPACK FOOTER //
// ./node_modules/cypher-editor-support/src/completion/CompletionTypes.js